<template>
  <div class="layout-container">
    <Header />
    <main class="layout-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" :key="$route.fullPath" />
        </transition>
      </router-view>
    </main>
    <Footer ref="footerRef" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import Header from '@/components/layout/Header.vue';
import Footer from '@/components/layout/Footer.vue';

const route = useRoute();
const footerRef = ref<InstanceType<typeof Footer> | null>(null);

// 监听路由变化，滚动到顶部
watch(
  () => route.path,
  () => {
    // 等待下一个tick确保DOM已更新
    nextTick(() => {
      scrollToTop();
    });
  }
);

// 滚动到顶部的函数
const scrollToTop = () => {
  // 尝试滚动主窗口
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth' // 添加平滑滚动效果
  });

  // 如果有滚动容器，也可以滚动容器
  const mainElement = document.querySelector('.layout-content');
  if (mainElement) {
    mainElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
};

// 暴露触发底部动画的方法
const triggerFooterAnimation = () => {
  footerRef.value?.triggerFooterAnimation();
};

defineExpose({
  triggerFooterAnimation,
  scrollToTop // 也可以暴露这个方法，方便其他地方调用
});
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layout-content {
  flex: 1;
  overflow-y: auto; /* 如果内容区域需要滚动，添加这个 */
}

/* 可选的过渡效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>